// extracted by mini-css-extract-plugin
module.exports = {"shortBannerWithLink":"ShortBannerWithKeyValue_shortBannerWithLink__fVjtz","link":"ShortBannerWithKeyValue_link__pB8sy"};